export const activeEmbedBlocks = (function ($) {


    function init() {
        $(window).on("load", function(){
            allowedBlocks();
        })
    }

    function allowedBlocks() {

        const allowedEmbedBlocks = [
            'youtube',
        ];

        if(wp && wp.blocks && wp.blocks.getBlockType) {

            wp.blocks.getBlockType('core/embed').variations.forEach(function (blockVariation) {
                if (
                    allowedEmbedBlocks.indexOf(blockVariation.name) === -1
                ) {
                    wp.blocks.unregisterBlockVariation('core/embed', blockVariation.name);
                }
            });
        }
    }

    return {
        init: init
    }


})(jQuery);
